/**
 * Resolve storefront slug for customer auth pages.
 * Prefer `?shop=slug`; fall back to a return path under `/shop/:slug`.
 */
export function resolveShopSlugFromAuthLocation(location: {
  search: string
  state?: { from?: { pathname?: string } | string | null } | null
}): string | null {
  const fromQuery = new URLSearchParams(location.search).get('shop')?.trim()
  if (fromQuery) return fromQuery

  const fromRaw = location.state?.from
  const fromPath = typeof fromRaw === 'string' ? fromRaw : fromRaw?.pathname || ''
  const match = fromPath.match(/^\/shop\/([^/?#]+)/i)
  return match?.[1] ? decodeURIComponent(match[1]) : null
}
